
import ProductListItem from '@/components/ProductListItem'
import Vue2Filters from 'vue2-filters'
import carouselScrollMixin from '@/mixins/carouselScrollMixin'

export default {
  name: 'ProductSliderListItem',
  components: { ProductListItem },
  mixins: [Vue2Filters.mixin, carouselScrollMixin],
  props: {
    products: Array,
    itemsPerSlide: {
      type: Number,
      default: 5,
    },
    isInCart: {
      type: Boolean,
      default: false,
    },
    isFromSlider: {
      type: Boolean,
      default: false,
    },
    showMoreButton: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    productMaxWidth: {
      type: Number,
      default: null,
    },
    customStylesSlides: {
      type: String,
      default: '',
    },
    cartMetadata: {
      type: Object,
      default: null,
    },
  },
  computed: {
    mobileItemWidth() {
      return this.$device.isTablet ? 'calc(100% / 2.3)' : 'calc(100% / 1.02)'
    },
    productsSlides() {
      const chunked_arr = []
      let copied = [...this.products]
      const numOfChild = Math.ceil(copied.length / this.itemsPerSlide)

      for (let i = 0; i < numOfChild; i++) {
        chunked_arr.push(copied.splice(0, this.itemsPerSlide))
      }
      if (
        this.showMoreButton &&
        chunked_arr[chunked_arr.length - 1].length === this.itemsPerSlide
      ) {
        chunked_arr.push([])
      }

      return chunked_arr
    },
  },
  watch: {
    products() {
      this.$nextTick(() => this.updateCarouselScrollState())
    },
  },
  methods: {
    generateQueryParams() {
      const validParams =
        this.params && typeof this.params === 'object' ? this.params : {}
      return {
        ...this.$route,
        query: {
          ...this.$route.query,
          ...validParams,
        },
      }
    },
    getProductClass(productIndex, slideLength) {
      if (this.isInCart) {
        return productIndex !== slideLength - 1 ? 'mr-sm-3' : ''
      } else {
        return slideLength != this.itemsPerSlide ? 'mr-sm-3' : ''
      }
    },
  },
}
